export default "__VITE_PUBLIC_ASSET__bdd874c3__"